import { PLACEHOLDER_CUISINES } from 'components/www/availability-search/filters/CuisineFilterButton';
import { consumer } from '@tock/coretypes';
import { useEffect, useState } from 'react';
import _ from 'lodash';

/**
 * Manage display of cuisine filters based on aggregations
 */
export const useCuisineAggregations = (
  selectedCuisines: string[],
  aggregations: consumer.Aggregations | undefined,
  aggregationsInternal?: consumer.Aggregations,
  setAggregationsInternal?: (aggs?: consumer.Aggregations) => void
) => {
  // allows deferring state control to an outside state
  const [aggregationsHookState, setAggregationsHookState] = useState(
    setAggregationsInternal ? undefined : aggregations
  );

  // we need to keep the aggs from no terms around so we don't disable the ones that aren't currently enabled
  useEffect(() => {
    if (selectedCuisines.length === 0) {
      if (setAggregationsInternal) {
        setAggregationsInternal(aggregations);
      } else {
        setAggregationsHookState(aggregations);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aggregations, setAggregationsInternal]);

  const cuisineAggregationKeys = new Set(
    _.keys(
      aggregationsInternal?.cuisineAggregation?.termToCount ||
        aggregationsHookState?.cuisineAggregation?.termToCount ||
        {}
    )
  );

  const cuisines = !_.isEmpty(cuisineAggregationKeys)
    ? PLACEHOLDER_CUISINES.filter((cuisine) => cuisineAggregationKeys.has(cuisine))
    : PLACEHOLDER_CUISINES;

  return { cuisines };
};
